module.exports = __webpack_public_path__ + "img/tall.680d3ba6.png";